import { render, staticRenderFns } from "./otaImport.vue?vue&type=template&id=b69bb5de&"
import script from "./otaImport.vue?vue&type=script&lang=js&"
export * from "./otaImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports